

// import React, { useEffect, useRef, useState } from "react";
// import Navbar from "../Navbar/Navbar";
// import { FaFacebook, FaLinkedin, FaTwitter } from "react-icons/fa";
// import "./style.css";
// import Footer from "../Footer/Footer";
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';
// import 'swiper/css/grid';
// import 'swiper/css/autoplay';
// import { Autoplay, Grid } from 'swiper/modules';
// import CountUp from 'react-countup';
// import slide1 from '../Images/slider-1.jpg'
// import slide2 from '../Images/slider-2.jpg'
// import slide3 from '../Images/slider-3.jpg'
// import slide4 from '../Images/slider-4.jpg'
// import slide5 from '../Images/slider-5.jpg'
// import slide6 from '../Images/slider-6.jpg'
// import slide7 from '../Images/slider-7.jpg'
// import slide8 from '../Images/slider-7.jpg'
// import slide9 from '../Images/slider-9.jpg'
// import slide10 from '../Images/slider-10.jpg'
// import { useNavigate } from "react-router-dom";

// import acuast from '../acuast.png';
// import cam from '../cam.png';
// import data from '../data.png';
// import graph from '../graph.png';
// import it from '../Services/nvy7t81j.png';
// import youtube from '../youtube.png';
// import client1 from '../Images/client1.png';
// import client2 from '../Images/client2.png';
// import client3 from '../Images/client3.png';
// import client4 from '../Images/client4.png';
// import client5 from '../Images/client1.png';
// import client6 from '../Images/client2.png';
// import client7 from '../Images/client3.png';
// import client8 from '../Images/client4.png';
// import client9 from '../Images/client4.png';
// import client10 from '../Images/client4.png';
// import HeroSlider from "./HeroSlider";
// import AboutSection from "./AboutSection";
// import ServicesSection from "./ServicesSection";
// import WhyChooseUs from "./WhyChooseUs";
// import FloatingScrollCTA from "./FloatingScrollCTA";
// import axios from "axios";






// const Home = () => {

//     const navigate = useNavigate();
// const services = [
//   {
//     title: "Building Acoustics",
//     img: acuast,
//     link: "/buildingAcoustics",
//   },
//   {
//     title: "AV Solutions",
//     img:  youtube,
//     link: "/av",
//   },
//   {
//     title: "IT/ICT & Data Centers",
//     img: it,
//     link: "/it",
//   },
//   {
//     title: "Security Risk Assessment",
//     img:data,
//     link: "/security-risk",
//   },
//   {
//     title: "Security Systems",
//     img: cam,
//     link: "/security",
//   },
//   {
//     title: "Project Management",
//     img:  graph,
//     link: "/pm",
//   },
// ];
// //  const slides = [
// //     { id: 1, title: "King Salman Park - 2 Mosque & Post Office", location: "Kingdom of Saudi Arabia", link: "projects/king_salman.html", bgImage: slide1 },
// //     { id: 2, title: "The Island Project - The MGM, Bellagio & Aria Hotels", location: "United Arab Emirates", link: "projects/island_project.html", bgImage: slide2 },
// //     { id: 3, title: "W Hotel and ALEF Residences, The Palm, Dubai", location: "United Arab Emirates", link: "projects/w_hotel.html", bgImage:slide3 },
// //     { id: 4, title: "King Abdul Aziz Road (KAAR) – 2 Kempinski, 1 Taj & 1 Hilton Hotels", location: "Kingdom of Saudi Arabia", link: "projects/king_abdul.html", bgImage: slide4 },
// //     { id: 5, title: "Avenues Riyadh - Hilton Hotel, Residential & Office Tower", location: "Kingdom of Saudi Arabia", link: "projects/avenue_riyadh.html", bgImage: slide5 },
// //     { id: 6, title: "New Palace of Justice", location: "Kuwait", link: "projects/new_palace.html", bgImage: slide6},
// //     { id: 7, title: "Sabah Al Salem Stadium", location: "Kuwait", link: "projects/sabah_al.html", bgImage: slide7},
// //     { id: 8, title: "Retal Ritz Carlton Resort", location: "Kingdom of Saudi Arabia", link: "projects/retal_ritz.html", bgImage:slide8 },
// //     { id: 9, title: "Yas w Hotel Refurbishment, Abu Dhabi", location: "United Arab Emirates", link: "projects/yes_w.html", bgImage: slide9},
   
// //   ];


// // const clientLogos = [client1, client2, client3, client4, client5, client6, client7, client8, client9, client10];


// const [clients, setClients] = useState([]);
// const [slides, setSlides] = useState([]);
// const [loading, setLoading] = useState(true);


// useEffect(() => {
//   AOS.init({ duration: 1000, once: true });
// }, []);

//   const [activeSlide, setActiveSlide] = useState(0);
//     const maxVisibleDots = 4;

// // Calculate start and end indexes based on current slide
// const startDot = Math.max(0, Math.min(activeSlide - 1, slides.length - maxVisibleDots));
// const visibleSlides = slides.slice(startDot, startDot + maxVisibleDots);

//   // Auto-scroll slides
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setActiveSlide((prev) => (prev + 1) % slides.length); // Loop through slides
//     }, 3000); // Change every 3 seconds

//     return () => clearInterval(interval);
//   }, []);

//   const [startIndex, setStartIndex] = useState(0);
//   const containerRef = useRef(null);

//   // Auto slide every 3 seconds
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setStartIndex((prev) =>
//         prev + 1 >= slides.length ? 0 : prev + 1
//       );
//     }, 3000);

//     return () => clearInterval(interval);
//   }, []);

//   // To get visible cards: 8 cards visible (4 per row * 2 rows)
//   const visibleCount = 8;

//   // Calculate indices to show cards in slider, looping around
//   const getVisibleProjects = () => {
//     let visible = [];
//     for (let i = 0; i < visibleCount; i++) {
//       visible.push(slides[(startIndex + i) % slides.length]);
//     }
//     return visible;
//   };

//   const visibleProjects = getVisibleProjects();


//   useEffect(() => {
//   axios.get("https://api.info-sight.net/api/clients")
//     .then(res => {
//       setClients(res.data);
//       setLoading(false);
//     })
//     .catch(err => {
//       console.log(err);
//       setLoading(false);
//     });
// }, []);


// useEffect(() => {
//   async function fetchSlides() {
//     try {
//       const res = await fetch("https://api.info-sight.net/api/projects");
//       const data = await res.json();

//       const formatted = data.map((item) => ({
//         id: item.id,
//         title: item.name,
//         location: item.country,
//         link: item.link || "#",
//         bgImage: item.image   // 🔥 Correct field for your <img src= >
//       }));

//       setSlides(formatted);
//       setLoading(false);
//     } catch (error) {
//       console.error("Failed to fetch slides:", error);
//       setLoading(false);
//     }
//   }

//   fetchSlides();
// }, []);



//   return (
//     <div className="app">
//       <Navbar />
   

// <HeroSlider/>
// <AboutSection/>

// <ServicesSection/>
// <WhyChooseUs/>
// <FloatingScrollCTA/>

// <section id="projects" className="section projects-section">
//   <div className="container1">
//     <h2 className="section-title" data-aos="fade-up">Our Projects</h2>
//     <p className="section-description" data-aos="fade-up" style={{color:'#1c1c1c'}}>
//       Discover our curated collection of projects, each a reflection of refined craftsmanship, elegant design, and uncompromising quality.
//     </p>
// <Swiper
//   modules={[Grid, Autoplay]}
//   slidesPerView={4}
//   grid={{ rows: 2, fill: 'row' }}
//   spaceBetween={24}

//   autoplay={{
//     delay: 2500,
//     disableOnInteraction: false,
//   }}
// breakpoints={{
//   0: {         // from 0px and up
//     slidesPerView: 1,
//     grid: { rows: 1 },
//   },
//   600: {
//     slidesPerView: 2,
//     grid: { rows: 2 },
//   },
//   1024: {
//     slidesPerView: 3,
//     grid: { rows: 2 },
//   },
// }}

//   className="projects-swiper"
// >
//   {slides.map((project, index) => (
//     <SwiperSlide key={index}>
//       <div className="project-card1">
//         <img src={project.bgImage} alt={project.title} />
//         <div className="overlay">
//           <h6>{project.title}</h6>  
//         </div>
//       </div>
//     </SwiperSlide>
//   ))}
// </Swiper>

//   </div>

// <style jsx>{`
// .projects-section {

//   padding: 5rem 2rem;
//   font-family: 'Poppins', sans-serif;
// }

//   .section-title {
//     text-align: center;
//     font-family: 'Playfair Display', serif;
//     font-size: 3rem;
//     color: #e50914; /* brighter red */
//     margin-bottom: 1rem;
//   }

//   .section-description {
//     max-width: 720px;
//     margin: 0 auto 3rem;
//     text-align: center;
//     color: #fff;
//     font-size: 1.1rem;
//     font-weight: 500;
//   }

//   .projects-swiper {
//     width: 100%;
//   }

//   .project-card1 {
//     height: 330px;
//     border-radius: 6px;
//     overflow: hidden;
//     position: relative;

//     transition: transform 0.3s ease;
//   }

//   .project-card1:hover {
//     transform: translateY(-5px);
//   }

//   .project-card1 img {
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//     transition: opacity 0.4s ease;
//   }

//   .project-card1:hover img {
//     opacity: 0.3;
//   }

// .project-card1 {
//   position: relative;
//   height: 330px;
//   overflow: hidden;
// }

// .project-card1 img {
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
//   transition: transform 0.4s ease;
// }

// /* Don't darken the image on hover */
// .project-card1:hover img {
//   transform: scale(1.03);
// }

// /* Updated overlay */
// .overlay {
//   position: absolute;
//   inset: 0;

//   display: flex;
//   align-items: center;
//   justify-content: center;
//   color: #e50914;
//   font-size: 1.5rem;
//   font-weight: 700;
//   text-align: center;
//   opacity: 0;
//   transition: opacity 0.4s ease;
//   padding: 1rem;

// }

// .project-card1:hover .overlay {
//   opacity: 1;
// }



//   .project-card1:hover .overlay {
//     opacity: 1;
//   }

//   @media (max-width: 768px) {
//     .section-title {
//       font-size: 2.2rem;
//     }

//     .section-description {
//       font-size: 1rem;
//       padding: 0 1rem;
//     }

//     .project-card1 {
//       height: 200px;
//     }
//   }

//   @media (max-width: 480px) {
//     .project-card1 {
//       height: 230px;
//     }

//     .overlay {
//       font-size: 1.1rem;
//       padding: 0 0.5rem;
//     }
//   }
// `}</style>

// </section>


// <section id="clients" className="clients-section">
//   <div className="container">

//     <h5 className="section-title">Our Valued Clients</h5>

//     <p className="section-description" style={{color:"black"}}>
//       Trusted by brands who shape excellence with us.
//     </p>

//     {loading && <p>Loading clients...</p>}

//     {!loading && (
//       <Swiper
//         modules={[Autoplay]}
//         slidesPerView={6}
//         spaceBetween={30}
//         loop
//         autoplay={{ delay: 2000 }}
//         breakpoints={{
//           320: { slidesPerView: 3 },
//           600: { slidesPerView: 4 },
//           1024: { slidesPerView: 6 }
//         }}
//       >

//         {clients.map((c) => (
//           <SwiperSlide key={c.id} className="client-card">

//             <div className="logo-wrapper">
//               <img src={c.image} alt={c.client_name} />
//             </div>

//             {/* <p className="client-name">{c.client_name}</p> */}

//           </SwiperSlide>
//         ))}

//       </Swiper>
//     )}

//   </div>

// <style jsx>{`

// .clients-section {
//   background: linear-gradient(135deg, #f7f7f7, #ffffff);
//   padding: 5rem 2rem;
//   font-family: 'Poppins', sans-serif;
// }

// .section-title {
//   text-align:center;
//   font-size:2.5rem;
//   color:#D50032;
// }

// .section-description {
//   text-align:center;
//   margin-bottom:3rem;
// }

// /* ✅ Each client box vertical layout */
// .client-card {
//   display:flex;
//   flex-direction:column;
//   align-items:center;
// }

// .logo-wrapper {
//   width: 90px;
//   height: 90px;
//   background: #fff;
//   border-radius: 12px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   box-shadow: 0 8px 24px rgba(0,0,0,0.06);
//   transition: 0.3s;
// }

// .logo-wrapper img {
//   width: 70px;        /* FIXED size instead of max-width */
//   height: auto;
//   object-fit: contain;
//   image-rendering: auto;
//   backface-visibility: hidden;
//   transform: translateZ(0);
//   transition: transform 0.3s ease;
// }

// .logo-wrapper:hover img {
//   transform: scale(1.05);
// }


// /* ✅ Client name under image */
// .client-name {
//   margin-top:10px;
//   font-size:0.85rem;
//   color:#d50032;
//   font-weight:600;
//   text-align:center;
// }

// @media(max-width:768px){
//   .logo-wrapper {
//     width:80px;
//     height:80px;
//   }
// }

// @media(max-width:480px){
//   .logo-wrapper {
//     width:70px;
//     height:70px;
//   }
// }

// `}</style>

// </section>

//       <Footer/>
//     </div>
//   );
// };

// export default Home;


import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/autoplay";
import { Autoplay, Grid, Navigation } from "swiper/modules";
import axios from "axios";

// Modern Icons for Real Estate UX
import {
  FaSearch,
  FaMapMarkerAlt,
  FaBed,
  FaBath,
  FaRulerCombined,
  FaBuilding,
  FaShieldAlt,
  FaArrowRight,
  FaCheckCircle,
} from "react-icons/fa";

// Sub-components
import HeroSlider from "./HeroSlider";
import AboutSection from "./AboutSection";
import ServicesSection from "./ServicesSection";
import WhyChooseUs from "./WhyChooseUs";
import FloatingScrollCTA from "./FloatingScrollCTA";

// High-Comfort Modern Real Estate Palette
const theme = {
  bgApp: "#F8FAF9",
  bgCard: "#FFFFFF",
  bgSubtle: "#F1F5F9",
  primary: "#0F172A", // Slate Navy
  accent: "#0D9488", // Soft Emerald Teal
  accentHover: "#0F766E",
  textDark: "#1E293B",
  textMuted: "#64748B",
  border: "#E2E8F0",
  shadowSm: "0 1px 3px rgba(0,0,0,0.05)",
  shadowMd: "0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01)",
};

const Home = () => {
  const [clients, setClients] = useState([]);
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);

  // Search Bar Filter State
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  // Fetch Clients
  useEffect(() => {
    axios
      .get("https://api.info-sight.net/api/clients")
      .then((res) => {
        setClients(res.data);
      })
      .catch((err) => console.error("Client fetch error:", err));
  }, []);

  // Fetch Projects / Real Estate Listings
  useEffect(() => {
    async function fetchSlides() {
      try {
        const res = await fetch("https://api.info-sight.net/api/projects");
        const data = await res.json();

        const formatted = data.map((item) => ({
          id: item.id,
          title: item.name,
          location: item.country || "Prime Location",
          category: item.category || "Residential",
          bgImage: item.image,
          beds: item.beds || 3,
          baths: item.baths || 2,
          area: item.area || "2,400 sqft",
        }));

        setSlides(formatted);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch slides:", error);
        setLoading(false);
      }
    }

    fetchSlides();
  }, []);

  // Filter Projects based on user input
  const filteredProjects = slides.filter((p) => {
    const matchesSearch =
      p.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      p.location.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory =
      selectedCategory === "All" || p.category.toLowerCase() === selectedCategory.toLowerCase();
    return matchesSearch && matchesCategory;
  });

  return (
    <div style={{ backgroundColor: theme.bgApp, color: theme.textDark, fontFamily: "'Inter', sans-serif" }}>
      <Navbar />

      {/* Hero Section */}
      <HeroSlider />

      {/* Real Estate Quick Search Bar Overlay */}
      {/* <section style={{ maxWidth: "1140px", margin: "-50px auto 40px", padding: "0 20px", position: "relative", zIndex: 10 }}>
        <div
          style={{
            backgroundColor: theme.bgCard,
            padding: "20px 24px",
            borderRadius: "16px",
            boxShadow: theme.shadowMd,
            border: `1px solid ${theme.border}`,
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "16px",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px", borderRight: `1px solid ${theme.border}`, paddingRight: "12px" }}>
            <FaMapMarkerAlt color={theme.accent} size={18} />
            <input
              type="text"
              placeholder="Search by project or location..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                width: "100%",
                border: "none",
                outline: "none",
                fontSize: "0.95rem",
                color: theme.textDark,
                backgroundColor: "transparent",
              }}
            />
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "10px", borderRight: `1px solid ${theme.border}`, paddingRight: "12px" }}>
            <FaBuilding color={theme.accent} size={18} />
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              style={{
                width: "100%",
                border: "none",
                outline: "none",
                fontSize: "0.95rem",
                color: theme.textDark,
                backgroundColor: "transparent",
                cursor: "pointer",
              }}
            >
              <option value="All">All Categories</option>
              <option value="Hospitality">Hospitality</option>
              <option value="Residential">Residential</option>
              <option value="Commercial">Commercial</option>
            </select>
          </div>

          <button
            style={{
              backgroundColor: theme.accent,
              color: "#FFF",
              border: "none",
              padding: "12px 20px",
              borderRadius: "10px",
              fontWeight: "600",
              fontSize: "0.95rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              cursor: "pointer",
              transition: "background 0.2s ease",
            }}
          >
            <FaSearch /> Explore Properties
          </button>
        </div>
      </section> */}

      {/* About & Services Sections */}
      <AboutSection />
      <ServicesSection />
      <WhyChooseUs />
      <FloatingScrollCTA />

      {/* Featured Real Estate Projects Section */}
      <section id="projects" style={{ padding: "80px 20px", maxWidth: "1200px", margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: "48px" }} data-aos="fade-up">
          {/* <span style={{ color: theme.accent, fontWeight: "600", fontSize: "0.9rem", letterSpacing: "1px", textTransform: "uppercase" }}>
            Exclusive Portfolio
          </span> */}
          <h2 style={{ fontSize: "2.25rem", color: theme.primary, fontWeight: "700", marginTop: "8px" }}>
            {/* Featured Properties & Developments */}
            Our Projects
          </h2>
          <p style={{ color: theme.textMuted, maxWidth: "600px", margin: "12px auto 0", fontSize: "1rem" }}>
            {/* Explore our architectural achievements engineered with precision, comfort, and state-of-the-art standards. */}
            
Discover our curated collection of projects, each a reflection of refined craftsmanship, elegant design, and uncompromising quality.
          </p>
        </div>

        {/* Property Carousel Grid */}
        <Swiper
          modules={[Grid, Autoplay]}
          slidesPerView={3}
          grid={{ rows: 1 }}
          spaceBetween={28}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          breakpoints={{
            0: { slidesPerView: 1, spaceBetween: 16 },
            640: { slidesPerView: 2, spaceBetween: 20 },
            1024: { slidesPerView: 3, spaceBetween: 28 },
          }}
          style={{ paddingBottom: "20px" }}
        >
          {filteredProjects.map((project, index) => (
            <SwiperSlide key={project.id || index}>
              <div
                style={{
                  backgroundColor: theme.bgCard,
                  borderRadius: "16px",
                  overflow: "hidden",
                  border: `1px solid ${theme.border}`,
                  boxShadow: theme.shadowSm,
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                  e.currentTarget.style.boxShadow = theme.shadowMd;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = theme.shadowSm;
                }}
              >
                {/* Property Card Image Header */}
                <div style={{ position: "relative", height: "230px", overflow: "hidden" }}>
                  <img
                    src={project.bgImage}
                    alt={project.title}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "14px",
                      left: "14px",
                      backgroundColor: "rgba(15, 23, 42, 0.75)",
                      backdropFilter: "blur(4px)",
                      color: "#FFF",
                      padding: "4px 12px",
                      borderRadius: "20px",
                      fontSize: "0.75rem",
                      fontWeight: "600",
                    }}
                  >
                    {project.category}
                  </div>
                </div>

                {/* Property Card Body */}
                <div style={{ padding: "20px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "6px", color: theme.accent, fontSize: "0.85rem", fontWeight: "500", marginBottom: "6px" }}>
                    <FaMapMarkerAlt /> {project.location}
                  </div>
                  <h3 style={{ fontSize: "1.1rem", fontWeight: "700", color: theme.primary, marginBottom: "16px", height: "2.8em", overflow: "hidden" }}>
                    {project.title}
                  </h3>

                  {/* Key Real Estate Specs */}
                  {/* <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      paddingTop: "14px",
                      borderTop: `1px solid ${theme.border}`,
                      color: theme.textMuted,
                      fontSize: "0.85rem",
                    }}
                  >
                    <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <FaBed color={theme.accent} /> {project.beds} Beds
                    </span>
                    <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <FaBath color={theme.accent} /> {project.baths} Baths
                    </span>
                    <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <FaRulerCombined color={theme.accent} /> {project.area}
                    </span>
                  </div> */}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      {/* Valued Clients Carousel Section */}
      <section style={{ backgroundColor: theme.bgSubtle, padding: "60px 20px", borderTop: `1px solid ${theme.border}` }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "36px" }}>
            <h3 style={{ fontSize: "1.5rem", fontWeight: "700", color: theme.primary }}>
              {/* Trusted Industry Partners */}
              Our Valued Clients
              </h3>
            <p style={{ color: theme.textMuted, fontSize: "0.95rem" }}>
              {/* Proudly associated with globally recognized developers and enterprises */}
              Trusted by brands who shape excellence with us.
              </p>
          </div>

          {!loading && (
            <Swiper
              modules={[Autoplay]}
              slidesPerView={6}
              spaceBetween={24}
              loop
              autoplay={{ delay: 2500 }}
              breakpoints={{
                320: { slidesPerView: 2 },
                600: { slidesPerView: 4 },
                1024: { slidesPerView: 6 },
              }}
            >
              {clients.map((c) => (
                <SwiperSlide key={c.id}>
                  <div
                    style={{
                      backgroundColor: theme.bgCard,
                      borderRadius: "12px",
                      height: "80px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "12px",
                      border: `1px solid ${theme.border}`,
                    }}
                  >
                    <img src={c.image} alt={c.client_name} style={{ maxHeight: "40px", maxWidth: "80%", objectFit: "contain" }} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;